import { PromoterOffer } from 'legacy/events/types';
import { getEligibilityText } from 'legacy/events/promoterOfferHelper';
import React from 'react';
import { useTranslation } from 'react-i18next';

const OfferDetailsHeader = ({ data }: { data?: PromoterOffer }) => {
  const { t } = useTranslation(['events']);
  const eligibilityText = getEligibilityText(data?.eligibilityCriteria);

  const rewards = data?.rewards?.kickbackRewards;
  const {
    kind,
    value,
    saleConditions: { unit }
  } = rewards[0];
  const sign = kind === 'amount' ? '$' : '%';
  const hasDiscount = data?.discount;

  return (
    <div>
      <div className="text-base font-bold text-[#202020]">{data?.name}</div>
      <div className="mt-4">
        <div className="text-xs font-bold text-[#575757] uppercase">
          {t('settings.promoterOffers.offerDetails.rewards')}
        </div>
        <div className="mt-1 text-[#202020] text-sm font-bold">
          {`${value}${sign} ${t('settings.promoterOffers.offerDetails.per')} ${unit}`}
        </div>
      </div>
      <div className="mt-4">
        <div className="text-xs font-bold text-[#575757] uppercase">
          {t('settings.promoterOffers.offerDetails.eligibility')}
        </div>
        <div className="mt-1 text-[#202020] text-sm font-bold">
          {eligibilityText}
        </div>
      </div>
      {hasDiscount && (
        <div className="mt-4">
          <div className="text-xs font-bold text-[#575757] uppercase">
            {t('settings.promoterOffers.offerDetails.purchaserBenefits')}
          </div>
          <div className="flex flex-row">
            <div className="text-[#202020] text-sm font-normal">
              {t('settings.promoterOffers.offerDetails.purchasersPayLess')}
            </div>
            <div className="font-semibold ml-1 text-[#202020] text-sm">
              {data?.discount?.value}{' '}
              {data?.discount?.kind === 'amount' ? '$' : '%'} {t('settings.promoterOffers.offerDetails.discount')}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OfferDetailsHeader;
